import './index.scss';

import { Slide1 } from '../../components/slides/slide1/slide1';
import { Slide2 } from '../../components/slides/slide2/slide2';
import { Slide3 } from '../../components/slides/slide3/slide3';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';

export const Carroussel = () => {

    const slides = [Slide1, Slide2, Slide3];

    return (

        <div className='container-page1'>

            <Swiper

                modules={[Pagination, Autoplay]}
                autoplay={{ delay: 4500 }}
                pagination
                loop
            >
                {slides.map(slides => (
                    <SwiperSlide>
                        {slides}
                    </SwiperSlide>
                ))}

            </Swiper>

        </div>

    )

}
